import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/home";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/StreamersPdf"
          element={
            <iframe
              src={`${process.env.PUBLIC_URL}/streamers.pdf`}
              width="100%"
              height="100%"
              title="PDF Viewer"
              style={{ border: "none", minHeight: "100vh" }}
            />
          }
        />
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
